import type { Editor } from '@aigovops/design-system';

/**
 * Public editorial masthead — mirrors the `editors` table row-for-row.
 *
 * Kept as a static frontend module (not fetched from /api/editors) because
 * the roster is small, public, and changes rarely. Landing, /editors, and
 * /editors/:id all import from here so one edit propagates.
 *
 * When the roster grows past ~10 editors OR when we want the queue's
 * `assignReviewer` UI to pick from the same list, promote this to an
 * /api/editors route backed by the `editors` table.
 *
 * Contract C12: every entry with `verified: true` must have a `profileUrl`
 * that returns HTTP 200 with a page body containing `displayName`.
 */
export const roster: Editor[] = [
  {
    id: 's-nielsen',
    displayName: 'Steve Nielsen',
    profileUrl: 'https://www.linkedin.com/in/stevenidataguy',
    credentials: ['GRC lead'],
    domains: [
      'NIST AI RMF',
      'ISO 42001',
      'EU AI Act',
      'FedRAMP',
      'HIPAA + AI',
      'HITRUST',
      'US state law',
    ],
    verified: true,
  },
];

export function findEditor(id: string): Editor | undefined {
  return roster.find((e) => e.id === id);
}
